import Vue from 'vue';
import _ from 'lodash';

Vue.prototype.$removeHTMLTags = (content) => {
  if(_.isEmpty(content)) {
    return '';
  }
  const regex = /(<([^>]+)>)/ig;
  return content.replace(regex, '').replace(/&nbsp;/ig, '').replace(/(^\s*)|(\s*$)/g, '');
}
